<template>
    <div class="selling-points">
        <div class="selling-points__inner">
            <div
                v-for="(sellingPoint, index) in sellingPoints"
                :key="index"
                class="selling-points__item"
            >
                <div class="selling-points__item-icon">
                    <img
                        :src="sellingPoint.icon.url"
                        :alt="sellingPoint.headline"
                        loading="lazy"
                    >
                </div>

                <div class="selling-points__item-content">
                    <span class="selling-points__item-content-popper">
                        <Popper
                            placement="top"
                            arrow
                        >
                            <button class="selling-points__item-headline-popper">
                                {{ sellingPoint.headline }}
                            </button>

                            <template #content>
                                <div class="selling-points__item-description-popper">
                                    {{ sellingPoint.description }}
                                </div>
                            </template>
                        </Popper>
                    </span>

                    <span class="selling-points__item-headline">
                        {{ sellingPoint.headline }}
                    </span>

                    <p class="selling-points__item-description">
                        {{ sellingPoint.description }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import Popper from 'vue3-popper';

defineProps({
    sellingPoints: {
        type: Object,
        required: true,
    },
});
</script>

<style lang="scss" scoped>
@use 'watson-theme-selling-points';

:deep(.popper #arrow::before) {
  background-color: rgb(var(--base-600));
}

:deep(.popper:hover),
:deep(.popper:hover > #arrow::before) {
  background-color: rgb(var(--base-600));
}
</style>
